import { createTheme, ThemeOptions } from '@mui/material/styles';

import * as colors from '../colors';
import { Theme } from '../types';

import { baseTheme } from './base-theme';

// Dark theme color adjustments
const darkPrimary = {
  main: '#2563EB', // Adjusted for better visibility on dark backgrounds
  light: '#60A5FA',
  dark: '#1D4ED8',
  contrastText: '#FFFFFF',
};

const darkSecondary = {
  main: '#10B981', // Adjusted for better visibility on dark backgrounds
  light: '#5EEAD4',
  dark: '#059669',
  contrastText: '#FFFFFF',
};

const darkBackground = {
  default: '#111827', // Dark background color
  paper: '#1F2937', // Dark paper color
};

const darkText = {
  primary: '#F9FAFB',
  secondary: '#D1D5DB',
  disabled: '#6B7280',
};

const darkThemeOptions: ThemeOptions = {
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: darkPrimary,
    secondary: darkSecondary,
    error: colors.error,
    warning: colors.warning,
    info: colors.info,
    success: colors.success,
    background: darkBackground,
    text: darkText,
    divider: 'rgba(255, 255, 255, 0.12)',
    grey: colors.grey,
    common: colors.common,
  },
  components: {
    ...baseTheme.components,
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: darkPrimary.dark,
          color: colors.common.white,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: darkBackground.paper,
          borderRight: `1px solid rgba(255, 255, 255, 0.12)`,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid rgba(255, 255, 255, 0.12)`,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: darkBackground.paper,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255, 255, 255, 0.23)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255, 255, 255, 0.4)',
          },
        },
      },
    },
  },
};

export const darkTheme = createTheme(darkThemeOptions) as Theme;
